<div class="legend">
  <ng-container
    i18n="
      Heading Control|First part of heading for control and
      result@@HeadingCraneControlAndResult"
    >Crane Control And Results</ng-container
  ><span *ngIf="kranname !== ''"
    >&nbsp;<ng-container i18n="Just For|Just the english word for@@For"
      >for</ng-container
    >
    {{ kranname }}</span
  >
</div>
<!-- legend -->

<div id="SteuerBereich">
  <div class="Kranbild">
    <img [src]="grafikBasis + modelGraphicsPath + kranmodell" />

    <div class="HALaenge">
      <div class="EingabeFeld">
        <select
          #HALaengeSelect
          [disabled]="haSelect_disabled == true"
          id="HALaenge"
          (change)="haLaengeAendern(HALaengeSelect.value)"
        >
          <option
            *ngFor="let haLaenge of haLaengen"
            [value]="haLaenge"
            [selected]="haLaenge == aktuelleHALaenge"
          >
            {{ rundeHAWerte(haLaenge, stellenNachEinheitenSystem) }}
          </option>
        </select>
      </div>
      <div class="HALaenge_EingabeFeld_Einheit">
        <span class="Bemassung">{{ laengenEinheit }}</span>
      </div>
    </div>
    <div class="Gegengew">
      <div class="EingabeFeldMittel">
        <input
          #GegengewichtInput
          id="Gegengew"
          [value]="aktuellesGegengewicht"
          readonly
        />
        <!--         Drinnen lassen, da das unter Umst�nden auch wieder ein SELECT wird -->
        <!--             <select #GegengewichtInput id="Gegengew" (change)="gegengewichtAendern(GegengewichtInput.value)">
                        <option *ngFor="let gegengewicht of gegengewichte" [value]="gegengewicht" [selected]="gegengewicht == aktuellesGegengewicht">{{gegengewicht}}</option>
                 </select> -->
      </div>
      <div class="Gegengew_EingabeFeld_Einheit">
        <span class="Bemassung">{{ gewichtsEinheit }}</span>
      </div>
    </div>
    <div class="HAWinkel">
      <div class="EingabeFeldMittel">
        <input
          #HAWinkelInput
          id="HAWinkel"
          [value]="HAWinkel"
          (change)="haWinkelAendern(HAWinkelInput.value)"
          (keyup.enter)="haWinkelAendern(HAWinkelInput.value)"
        />
      </div>
      <div class="HAWinkel_EingabeFeld_Einheit">
        <span class="Bemassung">°</span>
      </div>
    </div>
    <div class="Radius">
      <div class="EingabeFeld">
        <input
          #RadiusInput
          id="Radius"
          [value]="Radius"
          (change)="radiusAendern(RadiusInput.value)"
          (keyup.enter)="radiusAendern(RadiusInput.value)"
        />
      </div>
      <div class="Radius_EingabeFeld_Einheit">
        <span class="Bemassung">{{ laengenEinheit }}</span>
      </div>
    </div>
  </div>
  <!-- Kranbild -->

  <div class="LastDiagramm">
    <app-capacity-chart
      #LastGraph
      [xAchsenBeschriftung]="'R (' + laengenEinheit + ')'"
      i18n-[xAchsenBeschriftung]="
        Label X-axis|label for x-axis in capacity chart@@CapacityChartXAxis"
      [yAchsenBeschriftung]="'cap (' + gewichtsEinheit + ')'"
      i18n-[yAchsenBeschriftung]="
        Label Y-axis|label for y-axis in capacity chart@@CapacityChartYAxis"
      [toolTipFormat]="
        'Radius: #point.x#' +
        laengenEinheit +
        '<br />Capacity: #point.y#' +
        gewichtsEinheit
      "
      i18n-[toolTipFormat]="
        Label tooltip|label for tooltip in capacity chart@@CapacityChartTooltip"
      (serienSichtbarkeit)="aendereSerienSichtbarkeit($event)"
    >
    </app-capacity-chart>
  </div>
  <!-- LastDiagramm -->

  <div class="Info_Bereich">
    <div class="Hakenausrichtung">
      <img src="./deps/images/Hintergrund_Hoehe_OW.png" />
      <div class="Hakenhoehe">
        <div class="EingabeFeldMittel">
          <input id="Hoehe" value="{{ RollenkopfHoehe }}" readonly />
        </div>
        <div class="Hakenhoehe_EingabeFeld_Einheit">
          <span class="Bemassung">{{ laengenEinheit }}</span>
        </div>
      </div>
      <div class="Drehrichtung">
        <div class="EingabeFeldMittel">
          <input
            #OWWinkelInput
            id="OWWinkel"
            [value]="OWWinkel"
            (change)="owWinkelAendern(OWWinkelInput.value)"
            (keyup.enter)="owWinkelAendern(OWWinkelInput.value)"
          />
        </div>
        <div class="Drehrichtung_EingabeFeld_Einheit">
          <span class="Bemassung">°</span>
        </div>
      </div>
    </div>
    <div class="Umruestung bstooltip">
      <!--Button zum Umruesten-->
      <input
        class="Umruesten"
        [style.opacity]="sichtbarkeitUmruestung"
        type="button"
        (click)="kranUmruesten()"
        id="Umruesten"
        value=""
      />
      <span class="tooltiptext attop">{{ UmruestenTooltip }}</span>
    </div>

    <div class="Lastdaten">
      <div class="Lastdaten_Hintergrund">
        <img src="./deps/images/Hintergrund_Auslastung.png" />
      </div>
      <div class="AuslastungsAnzeige">
        <img class="AuslastungsAnzeige" [src]="auslastungsAnzeige" />
        <div class="AuslastungsAnzeige_Zahlen">
          <!--<div class="Beschreibung">Load Utilisation:</div> style="margin: 11px 0 0 42px "-->
          <div class="Auslastung">{{ Auslastung }}%</div>
        </div>
        <!-- 				<div class="AuslastungsAnzeige_Einheit"> -->
        <!-- 					<span class="Bemassung">%</span> -->
        <!-- 				</div> -->
      </div>

      <div class="max_gewicht">
        <div class="Kraneingabefelder">
          <!--<div class="Beschreibung">Load Max:</div> style="margin: 11px 0 0 42px "-->
          <div class="FeldWeit">{{ Maxload }}</div>
        </div>
        <div class="max_gewicht_Einheit">
          <span class="Bemassung">{{ gewichtsEinheit }}</span>
        </div>
      </div>
      <div class="eingabe_gewicht">
        <div class="Kraneingabefelder">
          <!--<div class="Beschreibung">Load:</div>-->
          <div class="EingabeFeldExtraLang">
            <input
              #LastInput
              id="Last"
              [value]="Last"
              (change)="lastAendern(LastInput.value)"
              (keyup.enter)="lastAendern(LastInput.value)"
            />
          </div>
        </div>
        <div class="eingabe_gewicht_Einheit">
          <span class="Bemassung">{{ gewichtsEinheit }}</span>
        </div>
      </div>
    </div>

    <div class="Ergebnis_Felder">
      <div class="Ergebnis_Felder_Hintergrundbild">
        <img src="./deps/images/Hintergrund_StuetzLasten.png" />
      </div>

      <!--Berechnungsergebnisse max hinten-->
      <div class="max_hinten">
        <div class="max_hinten_Berechnung_rechts">
          <div class="Berechnung_MAX">
            {{ maxHintenRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 520px; margin-top: 313px;"> -->
        <!-- 		<div class="Bemassung_MAX">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
        <div class="max_hinten_max">
          <div class="Bemassung_MAX">max</div>
        </div>
        <div class="max_hinten_Berechnung_links">
          <div class="Berechnung_MAX">
            {{ maxHintenLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 660px; margin-top: 313px;"> -->
        <!-- 		<div class="Bemassung_MAX">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
      </div>

      <!--Berechnungsergebnisse act hinten-->
      <div class="act_hinten">
        <div class="act_hinten_Berechnung_rechts">
          <div class="Berechnung">
            {{ actHintenRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 520px; margin-top: 343px;"> -->
        <!-- 		<div class="Bemassung_BER">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
        <div class="act_hinten_act">
          <div
            class="Bemassung_BER"
            i18n="Short for actual|Abbreviation for actual@@ActualAbbreviated"
          >
            act
          </div>
        </div>
        <div class="act_hinten_Berechnung_links">
          <div class="Berechnung">
            {{ actHintenLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 660px; margin-top: 343px;"> -->
        <!-- 		<div class="Bemassung_BER">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
      </div>

      <!--Stuetzweiten hinten-->
      <div class="stuetzweite_hinten">
        <div class="stuetzweite_hinten_rechts">
          <img [src]="stuetzeHR" />
        </div>
        <div class="stuetzweite_hinten_links">
          <img [src]="stuetzeHL" />
        </div>
        <div class="abstuetzungProzent_hinten">
          <div class="abstuetzungProzent_hinten_rechts">
            <div class="Berechnung">{{ abstuetzungProzent.stuetzeHR }}%</div>
          </div>
          <!-- 	<div class="Kraneingabefelder" -->
          <!-- 		style="margin-left: 520px; margin-top: 402px;"> -->
          <!-- 		<div class="Bemassung_BER">%</div> -->
          <!-- 	</div> -->
          <div class="abstuetzungProzent_hinten_links">
            <div class="Berechnung">{{ abstuetzungProzent.stuetzeHL }}%</div>
          </div>
          <!-- 	<div class="Kraneingabefelder" -->
          <!-- 		style="margin-left: 660px; margin-top: 402px;"> -->
          <!-- 		<div class="Bemassung_BER">%</div> -->
          <!-- 	</div> -->
        </div>
      </div>

      <div class="Grafik">
        <div class="ZeigerOWWinkel" [style.transform]="rotate">
          <img src="deps/images/OWDrehrichtung.png" />
        </div>
        <div *ngIf="drehbereichGrafik != ''" class="DrehbereichGrafik">
          <img [src]="drehbereichGrafik" />
        </div>
        <div *ngIf="drehbereichGrafik != ''" class="DrehbereichKlickGrafik">
          <app-image-angle-from-center
            [grafik]="drehbereichGrafikTransparent"
            [drehen]="90"
            [meinStyle]="{ width: '150px' }"
            (owWinkelGeaendert)="owWinkelAendern($event)"
          ></app-image-angle-from-center>
        </div>
      </div>

      <!--Stuetzweiten vorne-->
      <div class="stuetzweite_vorne">
        <div class="stuetzweite_vorne_rechts">
          <img [src]="stuetzeVR" />
        </div>
        <div class="stuetzweite_vorne_links">
          <img [src]="stuetzeVL" />
        </div>
        <div class="abstuetzungProzent_vorne">
          <div class="abstuetzungProzent_vorne_rechts">
            <div class="Berechnung">{{ abstuetzungProzent.stuetzeVR }}%</div>
          </div>
          <!-- 	<div class="Kraneingabefelder" -->
          <!-- 		style="margin-left: 520px; margin-top: 553px;"> -->
          <!-- 		<div class="Bemassung_BER">%</div> -->
          <!-- 	</div> -->
          <div class="abstuetzungProzent_vorne_links">
            <div class="Berechnung">{{ abstuetzungProzent.stuetzeVL }}%</div>
          </div>
          <!-- 	<div class="Kraneingabefelder" -->
          <!-- 		style="margin-left: 660px; margin-top: 553px;"> -->
          <!-- 		<div class="Bemassung_BER">%</div> -->
          <!-- 	</div> -->
        </div>
      </div>

      <!--Berechnungsergebnisse act vorne-->
      <div class="act_vorne">
        <div class="act_vorne_Berechnung_rechts">
          <div class="Berechnung">
            {{ actVorneRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 520px; margin-top: 614px;"> -->
        <!-- 		<div class="Bemassung_BER">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
        <div class="act_vorne_act">
          <div
            class="Bemassung_BER"
            i18n="Short for actual|Abbreviation for actual@@ActualAbbreviated"
          >
            act
          </div>
        </div>
        <div class="act_vorne_Berechnung_links">
          <div class="Berechnung">{{ actVorneLinks }}{{ gewichtsEinheit }}</div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 660px; margin-top: 614px;"> -->
        <!-- 		<div class="Bemassung_BER">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
      </div>

      <!--Berechnungsergebnisse max vorne-->
      <div class="max_vorne">
        <div class="max_vorne_Berechnung_rechts">
          <div class="Berechnung_MAX">
            {{ maxVorneRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 520px; margin-top: 644px;"> -->
        <!-- 		<div class="Bemassung_MAX">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
        <div class="max_vorne_max">
          <div class="Bemassung_MAX">max</div>
        </div>
        <div class="max_vorne_Berechnung_links">
          <div class="Berechnung_MAX">
            {{ maxVorneLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
        <!-- 	<div class="Kraneingabefelder" -->
        <!-- 		style="margin-left: 660px; margin-top: 644px;"> -->
        <!-- 		<div class="Bemassung_MAX">{{gewichtsEinheit}}</div> -->
        <!-- 	</div> -->
      </div>
    </div>
  </div>

  <div id="KurzBeschreibungUndDruck_MaxBase">
    <div class="FeldMitBeschreibung">
      <div
        class="Beschreibung_MaxBase"
        style="float: left; vertical-align: middle"
      >
        <ng-container
          i18n="
            Short Description|A short description of the
            project@@ShortDescription"
          >short description</ng-container
        >:
      </div>
      <div class="EingabeFeldInfo" style="float: left">
        <input
          type="text"
          maxlength="66"
          id="Information"
          [value]="description"
          (change)="setzeBeschreibung($event)"
          (keyup.enter)="setzeBeschreibung($event)"
        />
      </div>
    </div>
    <div style="float: right">
      <a class="css-button" (click)="Print()">
        <span class="css-button-text"
          ><ng-container
            i18n="Call print dialog|Labeling for print button@@printLabel"
            >Print</ng-container
          ></span
        >
      </a>
    </div>
  </div>
</div>

<div *ngIf="bitteWarten()" class="sanduhr">
  <div class="sanduhrDisplay"></div>
</div>
<app-fehlermeldung
  [FehlerUeberschrift]="FehlerUeberschrift"
  [FehlerHinweis]="FehlerHinweis"
  [(zeigeFehlerMeldungSchalter)]="zeigeFehlerMeldung"
  [FehlerCallback]="FehlerCallback"
></app-fehlermeldung>
<div *ngIf="zeigeDialog" class="sanduhr">
  <div class="Dialog" [innerHTML]="dialogHTML"></div>
</div>
<!-- <div style="position:absolute;top:400px;left:-200px"> -->
<!-- ladeKran: {{this.ladeKran}}<br /> -->
<!-- aktualisiereAnzeige: {{this.aktualisiereAnzeige}}<br /> -->
<!-- ergebnisseAktualisieren: {{this.ergebnisseAktualisieren}}<br /> -->
<!-- ergebnisseAktualisieren: {{this.ergebnisseAktualisieren}}<br /> -->
<!-- ruestdatenAktualisieren: {{this.ruestdatenAktualisieren}}<br /> -->
<!-- MAXWerteAktualisieren: {{this.MAXWerteAktualisieren}}<br /> -->
<!-- haSelect_disabled: {{this.haSelect_disabled}}<br /> -->
<!-- radiusGesetzt: {{this.radiusGesetzt}}<br /> -->
<!-- lastGesetzt: {{this.lastGesetzt}}<br /> -->
<!-- owWinkelGesetzt: {{this.owWinkelGesetzt}}<br /> -->
<!-- </div> -->
